import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["avatarProps"];
import React, { forwardRef } from "react";
import { Avatar } from "../../avatar";
import { BaseChip } from "../components/BaseChip";
import { AvatarWrapper } from "../styled/AvatarWrapper";
export var AvatarChip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var avatarProps = _ref.avatarProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseChip, _extends({}, rest, {
    ref: ref,
    color: "neutral",
    contentBefore: /*#__PURE__*/React.createElement(AvatarWrapper, null, /*#__PURE__*/React.createElement(Avatar, _extends({}, avatarProps, {
      "aria-hidden": true,
      role: "presentation",
      tabIndex: -1,
      size: "xxSmall"
    })))
  }));
});
AvatarChip.displayName = "AvatarChip";
//# sourceMappingURL=AvatarChip.js.map